/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   media bizo Youtube selectors
 */

import { INTERNAL_VIDEO_CDN_URL, MEDIA_CDN_URL } from '@zcode/nr-utils'

export const selectReelImage = (id: number | undefined) =>
  id ? `${MEDIA_CDN_URL}/video/${id}/thumbnail` : null

export const selectReelUrl = (id: number | undefined) =>
  id ? `${INTERNAL_VIDEO_CDN_URL}/${id}` : null
